import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Page } from "../../../app/core/pagination/pagination.model";
import { EditaisFiltro, EditaisService } from "./editais.service";
import { OrgaoService } from "./orgao.service";
import * as moment from "moment";

declare var $: any;

@Component({
  selector: "app-editais",
  templateUrl: "./editais.component.html",
  styleUrls: ["./editais.component.css"],
})
export class EditaisComponent implements OnInit {
  filtro = new EditaisFiltro();
  editais = [];
  entidades = [];
  param;
  page: Page;
  editalTitulo = "Chamamento Público";
  loading: boolean = false; // Variável para controle do estado de carregamento
  dataAtual: string;

  editalJustificativa: any = {};
  displayModalJustificativa: boolean = false;

  constructor(
    private editaisService: EditaisService,
    private orgaoService: OrgaoService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.dataAtual = moment().format("YYYY-MM-DD");
    this.filtro.entidadeConcedente = "";
    this.carregarEntidadesConcedentes();
    this.param = this.route.snapshot.params["tipo"];
    if (this.route.snapshot.params["tipo"] === "chamamento") {
      this.editalTitulo = "Chamamento Público";
    } else {
      this.editalTitulo = "Credenciamento";
    }
    this.pesquisar();

  }

  carregarEntidadesConcedentes() {
    this.orgaoService.listarOrgao().then((entidades) => {
      this.entidades = entidades;
    });
  }

  buscarPorCodigo(codigo) {
    this.editaisService.buscarPorCodigo(codigo).then((EditalChamamento) => {
      sessionStorage.setItem(
        "EditalChamamento",
        JSON.stringify(EditalChamamento)
      );
      this.router.navigate(["/pages/editais", EditalChamamento.id]);
    });

    // Subir ao topo
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      1000,
      "linear"
    );
  }

  pesquisar(pagina = 0) {
    this.filtro.pagina = pagina;
    this.loading = true;
    if (this.param === "chamamento") {
      this.editaisService.pesquisarChamamento(this.filtro).then(
        (resultado) => {
          this.editais = resultado.content;
          this.page = resultado;
          this.loading = false;
        },
        (erro) => {
          console.error("Erro ao carregar editais:", erro);
          this.loading = false;
        }
      );
    } else {
      this.filtro.tipoEdital = "CREDENCIAMENTO";
      this.editaisService.pesquisarCredenciamento(this.filtro).then(
        (resultado) => {
          this.editais = resultado.content;
          this.page = resultado;
          this.loading = false;
        },
        (erro) => {
          console.error("Erro ao carregar editais:", erro);
          this.loading = false;
        }
      );
    }
  }

  limparFiltro() {
    this.filtro = new EditaisFiltro();
    this.filtro.entidadeConcedente = "";
    this.pesquisar();
  }

  changePage(event) {
    this.filtro.itensPorPagina = event.size;
    this.filtro.pagina = event.page;
    this.pesquisar();
  }

  editalSelecionado(edital) {
    sessionStorage.setItem("Edital", JSON.stringify(edital));
  }

  mostraJustificativaCancelamento(edital) {
    this.editalJustificativa = edital;
    this.displayModalJustificativa = true;
  }
}
